import { hashString } from './math.js';
import { SONGS, getDailySong } from '../data/songs.js';

/** UTC date key YYYY-MM-DD */
export function todayKey(date = new Date()) {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Daily: same song and deterministic orbital direction for everyone that day.
 * If the VPS generated a fresh song today (dailyDate == today), it IS the
 * daily — it joins the Play catalog tomorrow. Otherwise fall back to the
 * deterministic pick among existing songs.
 */
export function getDailyChallenge(date = new Date()) {
  const key = todayKey(date);
  const seed = hashString(`orbeat-daily-${key}`);

  const generated = getDailySong();
  const base = generated && generated.dailyDate === key
    ? generated
    : SONGS[seed % SONGS.length];

  return {
    key,
    song: {
      ...base,
      id: `${base.id}-daily-${key}`,
      chartId: base.chartId ?? base.id,
      title: `${base.title} · Daily`,
      direction: seed % 2 === 0 ? 1 : -1
    }
  };
}
